import Layout from "../../Frames/Layout"
import { Stack, Alert } from "@mui/material"
import API from "../../../services/API"
import Loader from "../../Tools/Loader"
import { useParams } from "react-router-dom"
import Top from "./Top"
import Cards from "./Cards"
import Kpis from "./Kpis"
import Enrollments from "./Enrollments"
import { txt } from "../../../services/translation"
import EnrollButton from "./EnrollButton"
import { useQuery } from "react-query"

export default function Index(){

    const { id } = useParams()


    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ['company', 'user', id],
        queryFn: async () => {
            const response = await API.get(`/companies/me/users/${id}`);
            return response.data;
        }
    });


    return <Layout tab='company' menu='main'>

        {data && 
            <Stack spacing={3} sx={{mt: 3}}>

                <Top data={data} />

                <Cards data={data} />

                <Stack direction="row" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap" gap={1}>

                    <Kpis data={data } />

                    <EnrollButton userId={id} onEnroll={refetch} />

                </Stack>

                <Enrollments data={data}  />

            </Stack>
        }

        {isLoading && <Loader />}

        {isError && 
            <Alert severity='error'>{txt('contactLoadError')}</Alert>
        }

    </Layout>
}